module.exports = __webpack_public_path__ + "img/card-06.edee1895.png";